import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
  className?: string;
}

export default function MovieCard({ movie, className = "" }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className={`group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300 cursor-pointer ${className}`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}高清电影海报`}
          title={`${movie.title}高清电影海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-md bg-primary-950/80 px-2 py-1 font-label text-xs text-background-50">
          <i className="ri-star-fill text-accent-400" aria-hidden="true"></i>
          {movie.score.toFixed(1)}
        </span>
        <span className="absolute right-3 top-3 rounded-md bg-accent-500/90 px-2 py-1 font-label text-xs text-primary-950">
          HD
        </span>
      </div>

      <div className="flex flex-1 flex-col p-3.5 md:p-4">
        <h3 className="font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {movie.title}
        </h3>
        <div className="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 font-label text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="h-1 w-1 rounded-full bg-background-400"></span>
          <span>{movie.region}</span>
          <span className="h-1 w-1 rounded-full bg-background-400"></span>
          <span>{movie.duration}</span>
        </div>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {movie.genres.slice(0, 3).map((g) => (
            <span
              key={g}
              className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 font-label text-xs text-secondary-900"
            >
              {g}
            </span>
          ))}
        </div>
        <p className="mt-2.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {movie.excerpt}
        </p>
      </div>
    </Link>
  );
}